import React from 'react';
import { Chart, Tooltip, Axis, Coord, Geom } from 'bizcharts';
import { Row, Col } from 'antd';
import autoHeight from '../autoHeight';
import './index.less';
class Radar extends React.Component {
    constructor(props) {
        super(props);
        this.getG2Instance = (chart) => {
            this.chart = chart;
        };
        // for custom lengend view
        this.getLegendData = () => {
            if (!this.chart)
                return;
            const geom = this.chart.getAllGeoms()[0]; // 获取所有的图形
            if (!geom)
                return;
            const items = geom.get('dataArray') || []; // 获取图形对应的
            const legendData = items.map((item) => {
                // eslint-disable-next-line
                const origins = item.map((t) => t._origin);
                const result = {
                    name: origins[0].name,
                    color: item[0].color,
                    checked: true,
                    value: origins.reduce((p, n) => p + n.value, 0),
                };
                return result;
            });
            this.setState({
                legendData,
            });
        };
        this.handleRef = (n) => {
            this.node = n;
        };
        this.handleLegendClick = (item, i) => {
            const newItem = item;
            newItem.checked = !newItem.checked;
            const { legendData } = this.state;
            if (legendData) {
                legendData[i] = newItem;
                const filteredLegendData = legendData.filter((l) => l.checked).map((l) => l.name);
                if (this.chart) {
                    this.chart.filter('name', (val) => filteredLegendData.indexOf(val) > -1);
                    this.chart.repaint();
                }
                this.setState({
                    legendData,
                });
            }
        };
        this.state = {
            legendData: []
        };
    }
    componentDidMount() {
        this.getLegendData();
    }
    componentDidUpdate(preProps) {
        const { data } = this.props;
        if (data !== preProps.data) {
            this.getLegendData();
        }
    }
    render() {
        const defaultColors = [
            '#1890FF',
            '#FACC14',
            '#2FC25B',
            '#8543E0',
            '#F04864',
            '#13C2C2',
            '#fa8c16',
            '#a0d911',
        ];
        const { data = [], height = 0, title, hasLegend = false, forceFit = true, tickCount = 4, padding = [35, 30, 16, 30], animate = true, colors = defaultColors, } = this.props;
        const { legendData } = this.state;
        const scale = {
            value: {
                min: 0,
                tickCount,
            },
        };
        const chartHeight = height - (hasLegend ? 80 : 22);
        return (React.createElement("div", { className: "radar", style: { height } },
            title && React.createElement("h4", null, title),
            React.createElement(Chart, { scale: scale, height: chartHeight, forceFit: forceFit, data: data, padding: padding, animate: animate, onGetG2Instance: this.getG2Instance },
                React.createElement(Tooltip, null),
                React.createElement(Coord, { type: "polar" }),
                React.createElement(Axis, { name: "label", line: null, tickLine: null, grid: {
                        lineStyle: {
                            lineDash: undefined,
                        },
                        hideFirstLine: false,
                    } }),
                React.createElement(Axis, { name: "value", grid: {
                        type: 'polygon',
                        lineStyle: {
                            lineDash: undefined,
                        },
                    } }),
                React.createElement(Geom, { type: "line", position: "label*value", color: ['name', colors], size: 1 }),
                React.createElement(Geom, { type: "point", position: "label*value", color: ['name', colors], shape: "circle", size: 3 })),
            hasLegend && (React.createElement(Row, { className: "legend" }, legendData.map((item, i) => (React.createElement(Col, { span: 24 / legendData.length, key: item.name, onClick: () => this.handleLegendClick(item, i) },
                React.createElement("div", { className: "legendItem" },
                    React.createElement("p", null,
                        React.createElement("span", { className: "dot", style: {
                                backgroundColor: !item.checked ? '#aaa' : item.color,
                            } }),
                        React.createElement("span", null, item.name)),
                    React.createElement("h6", null, item.value)))))))));
    }
}
export default autoHeight()(Radar);
